<template>
  <section class="section">
    <!-- <div class="section-header">
      <h1>{{ $t("messages.confirmReqRegister.title") }}</h1>
    </div> -->
    <div class="section-body">
      <div class="card" v-if="!isEdit">
        <div class="card-header">
          <v-icon color="pink">search</v-icon>
          <h4>{{ $t("messages.general.searchShowInfo") }}</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.academicYear") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <AcademicYear
                      :onChanged="onSelYearChanged"
                      :selectedVal="selYear"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.semester") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Semester
                      :onChanged="onSelSemesterChanged"
                      :selectedVal="selSemester"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.educationLvl") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Level
                      :onChanged="onSelLvlChanged"
                      :selectedVal="selLvl"
                      :disabled="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.classCode") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="input-group">
                            <div class="form-inline">
                              <div class="input-group-append">
                                <input
                                  type="text"
                                  class="form-control col mr-2"
                                  style="margin-right: 0px !important"
                                  v-model="courseCode"
                                  @keypress="handleSearchClsKey($event)"
                                />
                                <button
                                  type="button"
                                  class="btn btn-temp btn-lg"
                                  @click="handleSearchCls()"
                                >
                                  <i class="fas fa-search"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              disabled
                              v-model="courseName"
                            />
                            <button
                              type="button"
                              class="btn btn-danger btn-lg"
                              @click="handleClrCourse()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.section") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select
                        class="form-control"
                        @change="onSelSectionChanged($event)"
                      >
                        <option :selected="selSection == '00'" value="00"
                          >---{{
                            $t("messages.general.notSpecified")
                          }}---</option
                        >
                        <option
                          v-for="(item, index) in sections"
                          :key="index"
                          :value="item.SECTION_TEXT"
                          :selected="selSection == item.SECTION_TEXT"
                        >
                          {{ item.SECTION_TEXT }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.extraReq") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select
                        class="form-control"
                        @change="onSelExReqChanged($event)"
                      >
                        <option :selected="selExReq == '0'" value="0"
                          >---{{
                            $t("messages.general.notSpecified")
                          }}---</option
                        >
                        <option :selected="selExReq == 'Y'" value="Y">{{
                          $t("messages.general.allow")
                        }}</option>
                        <option :selected="selExReq == 'N'" value="N">{{
                          $t("messages.general.notAllow")
                        }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.confirmStatus") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select
                        class="form-control"
                        @change="onSelConfirmChanged($event)"
                      >
                        <option :selected="selConfirm == '0'" value="0"
                          >---{{
                            $t("messages.general.notSpecified")
                          }}---</option
                        >
                        <option :selected="selConfirm == 'Y'" value="Y">{{
                          $t("messages.general.confirmed")
                        }}</option>
                        <option :selected="selConfirm == 'N'" value="N">{{
                          $t("messages.general.notConfirmed")
                        }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.approveStatus") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select
                        class="form-control"
                        @change="onSelapproveChanged($event)"
                      >
                        <option :selected="selApprove == '0'" value="0"
                          >---{{
                            $t("messages.general.notSpecified")
                          }}---</option
                        >
                        <option :selected="selApprove == 'Y'" value="Y">{{
                          $t("messages.general.randomApprove")
                        }}</option>
                        <option :selected="selApprove == 'N'" value="N">{{
                          $t("messages.general.notRandomApprove")
                        }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.typeOfCourse") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <GetClassType
                      :onChanged="onSelTypeChanged"
                      :selectedVal="selType"
                      :disabled="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleSearchConfirmResult()"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-light btn-lg"
                    @click="handleClearScreen()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTable.sortBy"
              :sort-desc.sync="bTable.sortDesc"
              :items="bTable.items"
              :fields="bTable.fields"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTable.items.length"
                  v-model="currentPage"
                  :per-page="perPage"
                />
                <div
                  v-if="bTable.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPage > 1
                        ? (currentPage - 1) * perPage + 1
                        : currentPage
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPage * perPage > bTable.items.length
                        ? bTable.items.length
                        : currentPage * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTable.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
              </template>

              <template v-slot:cell(action)="data">
                <v-btn text icon @click="goTo(data.item, data.index)">
                  <v-icon @click="goTo(data.item, data.index)">edit</v-icon>
                </v-btn>
              </template>

              <template v-slot:cell(TOTALCONFIRM)="data">
                <a
                  @click="handleSelectTotalConfirm(data.item, data.index)"
                  style="text-decoration: underline;"
                >
                  {{ data.item.TOTALCONFIRM }}
                </a>
              </template>
              <template v-slot:cell(TOTALENROLL)="data">
                <a
                  @click="handleSelectTotalEnroll(data.item, data.index)"
                  style="text-decoration: underline;"
                >
                  {{ data.item.TOTALENROLL }}
                </a>
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTable.items.length"
                    v-model="currentPage"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTable.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPage > 1
                          ? (currentPage - 1) * perPage + 1
                          : currentPage
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPage * perPage > bTable.items.length
                          ? bTable.items.length
                          : currentPage * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTable.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </div>
      </div>
      <div class="card" v-if="isEdit">
        <div class="card-header">
          <v-icon color="pink">edit</v-icon>
          <h4>{{ $t("messages.general.manageData") }}</h4>
        </div>
        <v-card width="100%">
          <v-row>
            <v-col
              cols="10"
              style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
            >
              <p style="color: red; margin: 0">*</p>
            </v-col>
            <v-col
              style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
            >
              <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
            </v-col>
          </v-row>
        </v-card>
        <form>
          <div class="information-block">
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.academicYear") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selectedDetail.ACADYEAR }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.semester") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selectedDetail.SEMESTER }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.classId") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selectedDetail.COURSECODE }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.className") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selectedDetail.COURSENAME }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.section") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selectedDetail.SECTION_TEXT }}</div>
                  </div>
                  <div class="col no-margin-padding" style="flex: 0 0 12em;">
                    <div v-if="extraReg">
                      <label style="background-color: #EA7053; color: #CADACD;">
                        {{ $t("messages.general.extraReq") }}
                      </label>
                    </div>
                  </div>
                  <div class="col no-margin-padding">
                    <div v-if="extraReg" class="form-inline">
                      <v-switch
                        v-model="extraRegVal"
                        hide-details="true"
                        style="margin: 0 0 0 15px; padding: 0;"
                      ></v-switch
                      >&nbsp;&nbsp;&nbsp;
                      <v-btn
                        icon
                        @click="handleExtraReqEdit()"
                        style="height: 0;"
                      >
                        <v-icon>save</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.room") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selectedDetail.ROOMNAME }}</div>
                  </div>
                  <div class="col no-margin-padding" style="flex: 0 0 12em;">
                    <div>{{ $t("messages.general.roomCapacity") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div style="padding-left: 15px;">
                      {{ selectedDetail.ROOMCAPACITY }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.reqAmount") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selectedDetail.TOTALREQUEST }}</div>
                  </div>
                  <div class="col no-margin-padding" style="flex: 0 0 12em;">
                    <div>{{ $t("messages.general.receiveAmount") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div
                      v-if="!isEditTotalSumSeat"
                      class="form-inline"
                      style="padding-left: 15px;"
                    >
                      {{ totalSumSeat }}&nbsp;&nbsp;&nbsp;
                      <v-btn
                        v-if="selectedDetail.IS_EDIT_TOTALSEAT == 'Y'"
                        icon
                        @click="handleEditTotalSeat()"
                        style="height: 0; margin-left: 15px;"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </div>
                    <div v-else class="form-inline">
                      <input
                        type="text"
                        class="form-control"
                        style="margin-right: 0px !important; margin-left: 10px; width: 80px"
                        v-model="totalSumSeat"
                      />
                      <v-btn
                        icon
                        @click="handleAdjustTotalSeat()"
                        style="height: 0; margin-left: 15px;"
                      >
                        <v-icon>save</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        @click="handleClearTotalSeat()"
                        style="height: 0;"
                      >
                        <v-icon>close</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.registeredAmount") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selectedDetail.TOTALENROLL }}</div>
                  </div>
                  <div class="col no-margin-padding" style="flex: 0 0 12em;">
                    <div>{{ $t("messages.general.remianseat") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div style="padding-left: 15px;">
                      {{ selectedDetail.REMAINSEAT }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div style="padding-left: 15px;">
              <label class="text-danger">{{
                $t("messages.general.remarkRemainSeat")
              }}</label>
            </div>
          </div>
          <div class="form-row" v-if="false">
            <div class="col no-padding-bottom">
              <div class="form-group" style="margin-bottom: 0;">
                <div class="form-inline">
                  <div
                    class="custom-control custom-radio custom-control-inline"
                  >
                    <input
                      type="radio"
                      id="rdConfirmType1"
                      name="rdConfirmType"
                      class="custom-control-input"
                      v-model="confirmType"
                      v-bind:value="0"
                    />
                    <label
                      class="custom-control-label"
                      for="rdConfirmType1"
                      :style="confirmType == 0 ? 'background-color: red' : ''"
                      >{{ $t("messages.general.receiveRoomCapacity") }}</label
                    >
                    <label class="text-danger"
                      >&nbsp;( {{ selectedDetail.ROOMCAPACITY }}
                      {{ $t("messages.general.seat") }} )</label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="form-group" style="margin-bottom: 0;">
                <div class="form-inline">
                  <div
                    class="custom-control custom-radio custom-control-inline"
                  >
                    <input
                      type="radio"
                      id="rdConfirmType2"
                      name="rdConfirmType"
                      class="custom-control-input"
                      v-model="confirmType"
                      v-bind:value="1"
                    />
                    <label
                      class="custom-control-label"
                      for="rdConfirmType2"
                      :style="confirmType == 1 ? 'background-color: red' : ''"
                      >{{ $t("messages.general.receiveReqAmount") }}</label
                    >
                    <label class="text-danger"
                      >&nbsp;( {{ totalRequest }}
                      {{ $t("messages.general.person") }} )</label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div class="form-group" style="margin-bottom: 0;">
                <div class="form-inline">
                  <div
                    class="custom-control custom-radio custom-control-inline"
                  >
                    <input
                      type="radio"
                      id="rdConfirmType3"
                      name="rdConfirmType"
                      class="custom-control-input"
                      v-model="confirmType"
                      v-bind:value="2"
                    />
                    <label
                      class="custom-control-label"
                      for="rdConfirmType3"
                      :style="confirmType == 2 ? 'background-color: red' : ''"
                      >{{ $t("messages.general.receiveSpec") }}</label
                    >
                    <label>
                      <input
                        type="text"
                        class="form-control col mr-2"
                        style="margin-right: 0px !important; margin-left: 10px; width: 80px"
                        v-model="totalConfirm"
                        :disabled="totalConfirmDisabled"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col no-padding-bottom">
              <div
                class="form-group"
                style="margin-bottom: 0; backgroud-color: red"
              >
                <div class="form-inline">
                  <div
                    class="custom-control custom-radio custom-control-inline"
                  >
                    <div>
                      <input
                        type="radio"
                        id="rdConfirmType4"
                        name="rdConfirmType"
                        class="custom-control-input"
                        v-model="confirmType"
                        v-bind:value="3"
                      />
                      <label
                        class="custom-control-label"
                        for="rdConfirmType4"
                        :style="confirmType == 3 ? 'background-color: red' : ''"
                        >{{ $t("messages.general.receiveSpecPerson") }}</label
                      >
                    </div>
                    &nbsp;&nbsp;&nbsp;
                    <button
                      v-if="showPerson && confirmType == 3"
                      type="button"
                      class="btn btn-primary btn-bg"
                      @click="handleGetReqConfirmStudentDetail()"
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                    &nbsp;
                    <button
                      v-if="showPerson && confirmType == 3"
                      type="button"
                      class="btn btn-primary btn-bg"
                      @click="handleStudentSelectList()"
                    >
                      <i class="fas fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="form-row flex-column justify-content-center align-items-center mt-5"
          >
            <div class="form-group">
              <div class="form-inline">
                <button
                  v-if="selectedDetail.IS_SHOWCONFIRMBUTTON == 'Y'"
                  :disabled="confirmType == 3 && studentIdList.length == 0"
                  type="button"
                  class="btn btn-primary btn-lg"
                  @click="handleConfirmReq()"
                >
                  {{ $t("messages.general.confirmReq") }}</button
                >&nbsp;&nbsp;&nbsp;
                <button
                  type="button"
                  class="btn btn-light btn-lg"
                  @click="goBack()"
                >
                  {{ $t("messages.general.backhome") }}</button
                >&nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <v-dialog
      v-model="dialogSearchProgram"
      hide-overlay
      scrollable
      max-width="80%"
    >
      <v-card tile>
        <v-toolbar flat dense>
          <v-icon>search</v-icon>
          <v-toolbar-title>{{
            $t("messages.general.classList")
          }}</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogSearchProgram = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.classId") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <input
                        v-model="dlgCourseCode"
                        type="text"
                        class="form-control col mr-2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.className") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <input
                        v-model="dlgCourseName"
                        type="text"
                        class="form-control col mr-2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.faculty") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Faculty
                      :onChanged="onSelFacultyCourseChanged"
                      :selectedVal="selFacultyCourse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.department") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Department
                      :onChanged="onSelDepartmentCourseChanged"
                      :facultyid="selFacultyCourse"
                      :selectedVal="selDepartmentCourse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    class="btn btn-primary btn-lg"
                    type="button"
                    @click="handleCourseSearch()"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    class="btn btn-light btn-lg"
                    type="button"
                    @click="cleartCourseProgram()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTableProgram.sortBy"
              :sort-desc.sync="bTableProgram.sortDesc"
              :items="bTableProgram.items"
              :fields="bTableProgram.fields"
              :per-page="perPage"
              :current-page="currentPageProgram"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTableProgram.items.length"
                  v-model="currentPageProgram"
                  :per-page="perPage"
                />
                <div
                  v-if="bTableProgram.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPageProgram > 1
                        ? (currentPageProgram - 1) * perPage + 1
                        : currentPageProgram
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPageProgram * perPage > bTableProgram.items.length
                        ? bTableProgram.items.length
                        : currentPageProgram * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableProgram.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTableProgram.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableProgram.items.length).toLocaleString() }}
                </div>
              </template>

              <template v-slot:cell(COURSECODE)="data">
                <a
                  @click="handleSelectCourse(data.item, data.index)"
                  style="text-decoration: underline;"
                >
                  {{ data.item.COURSECODE }}
                </a>
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableProgram.items.length"
                    v-model="currentPageProgram"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTableProgram.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPageProgram > 1
                          ? (currentPageProgram - 1) * perPage + 1
                          : currentPageProgram
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageProgram * perPage >
                          bTableProgram.items.length
                          ? bTableProgram.items.length
                          : currentPageProgram * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableProgram.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTableProgram.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableProgram.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirmSuccess" max-width="600px">
      <v-card tile>
        <v-toolbar flat dense color="light-green accent-3">
          <v-icon color="light-green darken-2">fa-check</v-icon>
          <v-toolbar-title style="color: green;"
            >&nbsp;{{
              $t("messages.reqRegister.confirmPopupText")
            }}</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogConfirmSuccess = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark color="green accent-1">
          <br />
          <span v-html="successText" style="color: green;">{{
            successText
          }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogError" max-width="600px">
      <v-card tile>
        <v-toolbar flat dense color="red darken-3">
          <v-icon color="red lighten-5">fa-exclamation-circle</v-icon>
          <v-toolbar-title style="color: #ffebee;"
            >&nbsp;{{ dialogErrorTitle }}</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogError = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark color="red accent-1">
          <br />
          <span style="color: red;" v-html="errorText">{{ errorText }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogStudents"
      hide-overlay
      scrollable
      max-width="80%"
      content-class="dlgCustomHeight"
    >
      <v-card tile>
        <v-toolbar flat dense>
          <v-icon>search</v-icon>
          <v-toolbar-title>{{
            $t("messages.confirmReqRegister.studentReqList")
          }}</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogStudents = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark style="height: 100%;">
          <form>
            <div
            v-if="!isHideButtonandMark"
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group" style="width: 100%">
                <div class="form-inline">
                  <div
                    class="form-group"
                    style="width: 70%; justify-content: left;"
                  >
                    <label class="text-danger">{{
                      $t("messages.confirmReqRegister.remarkStudent")
                    }}</label>
                  </div>
                  <div
                    class="form-group"
                    style="width: 30%; justify-content: flex-end;"
                  >
                    <div class="form-inline">
                      <button
                        class="btn btn-primary btn-lg"
                        type="button"
                        @click="handleStudentSelect()"
                      >
                        {{
                          isStudentSelect
                            ? $t("messages.general.select")
                            : $t("messages.general.delRecord")
                        }}
                      </button>
                    </div>
                  </div>
                </div>
              </div> 
            </div>
          </form>
          <v-card style="height: 100%; overflowX: auto; position: relative;">
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTableStudentReg.sortBy"
              :sort-desc.sync="bTableStudentReg.sortDesc"
              :items="bTableStudentReg.items"
              :fields="bTableStudentReg.fields"
              :per-page="perPageStudentReg"
              :current-page="currentPageStudentReg"
              style="position: relative; overflowY: hidden; padding-bottom: 60px"
            >
              <template slot="table-caption">
                <div>
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPageStudentReg"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableStudentReg.items.length"
                    v-model="currentPageStudentReg"
                    :per-page="perPageStudentReg"
                  />
                  <div
                    v-if="bTableStudentReg.items.length > 0"
                    class="float-right data-table-page-info"
                  >
                    {{
                      Number(
                        currentPageStudentReg > 1
                          ? (currentPageStudentReg - 1) * perPageStudentReg + 1
                          : currentPageStudentReg
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageStudentReg * perPageStudentReg >
                          bTableStudentReg.items.length
                          ? bTableStudentReg.items.length
                          : currentPageStudentReg * perPageStudentReg
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableStudentReg.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTableStudentReg.items.length <= 0"
                    class="float-right data-table-page-info"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableStudentReg.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>

              <template v-slot:head(selStudent)="">
                <input
                  type="checkbox"
                  id="chkAll"
                  @change="handleChkAll($event)"
                  :checked="
                    bTableStudentReg.items.length > 0 &&
                      bTableStudentReg.items.length == tmpStudentList.length
                  "
                />
              </template>

              <template v-slot:cell(selStudent)="data">
                <input
                  type="checkbox"
                  id="chk"
                  @change="handleChk($event, data)"
                  :checked="data.value"
                />
              </template>

              <template v-slot:cell(STUDENTCODE_TEXT)="data">
                <label
                  :class="data.item.IS_RESERVE === 'Y' ? 'text-danger' : ''"
                  >{{ data.value }}</label
                >
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -7px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPageStudentReg"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableStudentReg.items.length"
                    v-model="currentPageStudentReg"
                    :per-page="perPageStudentReg"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTableStudentReg.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPageStudentReg > 1
                          ? (currentPageStudentReg - 1) * perPageStudentReg + 1
                          : currentPageStudentReg
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageStudentReg * perPageStudentReg >
                          bTableStudentReg.items.length
                          ? bTableStudentReg.items.length
                          : currentPageStudentReg * perPageStudentReg
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableStudentReg.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTableStudentReg.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableStudentReg.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogStudentsShowDetail"
      hide-overlay
      scrollable
      max-width="80%"
      content-class="dlgCustomHeight"
    >
      <v-card tile>
        <v-toolbar flat dense>
          <v-icon>search</v-icon>
          <v-toolbar-title>{{
            $t("messages.confirmReqRegister.studentReqList")
          }}</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogStudentsShowDetail = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark style="height: 100%;">
          <form>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group" style="width: 100%">
                <div class="form-inline">
                  <div
                    class="form-group"
                    style="width: 70%; justify-content: left;"
                  >
                    <label class="text-danger">{{
                      $t("messages.confirmReqRegister.remarkStudent")
                    }}</label>
                  </div>
                  <div
                    class="form-group"
                    style="width: 30%; justify-content: flex-end;"
                  >
                    <div class="form-inline"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <v-card style="height: 100%; overflowX: auto; position: relative;">
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTableStudentRegShow.sortBy"
              :sort-desc.sync="bTableStudentRegShow.sortDesc"
              :items="bTableStudentRegShow.items"
              :fields="bTableStudentRegShow.fields"
              :per-page="perPageStudentReg"
              :current-page="currentPageStudentReg"
              style="position: relative; overflowY: hidden; padding-bottom: 55px"
            >
              <template slot="table-caption">
                <div>
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPageStudentReg"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableStudentRegShow.items.length"
                    v-model="currentPageStudentReg"
                    :per-page="perPageStudentReg"
                  />
                  <div
                    v-if="bTableStudentRegShow.items.length > 0"
                    class="float-right data-table-page-info"
                  >
                    {{
                      Number(
                        currentPageStudentReg > 1
                          ? (currentPageStudentReg - 1) * perPageStudentReg + 1
                          : currentPageStudentReg
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageStudentReg * perPageStudentReg >
                          bTableStudentRegShow.items.length
                          ? bTableStudentRegShow.items.length
                          : currentPageStudentReg * perPageStudentReg
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{
                      Number(bTableStudentRegShow.items.length).toLocaleString()
                    }}
                  </div>
                  <div
                    v-if="bTableStudentRegShow.items.length <= 0"
                    class="float-right data-table-page-info"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{
                      Number(bTableStudentRegShow.items.length).toLocaleString()
                    }}
                  </div>
                </div>
              </template>
              <template v-slot:cell(STUDENTCODE)="data">
                <label
                  :class="data.item.IS_RESERVE === 'Y' ? 'text-danger' : ''"
                  >{{ data.value }}</label
                >
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -7px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPageStudentReg"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableStudentRegShow.items.length"
                    v-model="currentPageStudentReg"
                    :per-page="perPageStudentReg"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTableStudentRegShow.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPageStudentReg > 1
                          ? (currentPageStudentReg - 1) * perPageStudentReg + 1
                          : currentPageStudentReg
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageStudentReg * perPageStudentReg >
                          bTableStudentRegShow.items.length
                          ? bTableStudentRegShow.items.length
                          : currentPageStudentReg * perPageStudentReg
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{
                      Number(bTableStudentRegShow.items.length).toLocaleString()
                    }}
                  </div>
                  <div
                    v-if="bTableStudentRegShow.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{
                      Number(bTableStudentRegShow.items.length).toLocaleString()
                    }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogRandom"
      hide-overlay
      scrollable
      max-width="50%"
      persistent
    >
      <v-card tile>
        <v-toolbar flat dense>
          <v-icon>edit</v-icon>
          <v-toolbar-title>{{
            $t("messages.randomReqRegister.title")
          }}</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogRandom = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label class="no-margin-bottom" style="font-size: 16px;">{{
                      $t("messages.general.randomType")
                    }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-group" style="margin-bottom: 0;">
                      <div class="form-inline">
                        <div
                          class="custom-control custom-radio custom-control-inline"
                        >
                          <input
                            type="radio"
                            id="rdType1"
                            name="reType"
                            class="custom-control-input"
                            v-model="randomType"
                            value="AC"
                          />
                          <label
                            class="custom-control-label"
                            style="font-size: 16px; color: #000;"
                            for="rdType1"
                            >{{ $t("messages.general.useCondition") }}</label
                          >
                        </div>
                        <div
                          class="custom-control custom-radio custom-control-inline"
                        >
                          <input
                            type="radio"
                            id="rdType2"
                            name="reType"
                            class="custom-control-input"
                            v-model="randomType"
                            value="AN"
                          />
                          <label
                            class="custom-control-label"
                            style="font-size: 16px; color: #000;"
                            for="rdType2"
                            >{{ $t("messages.general.unUseCondition") }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    class="btn btn-primary btn-lg"
                    type="button"
                    @click="handleApprove()"
                  >
                    {{ $t("messages.general.approve") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import AcademicYear from "../components/Dropdown/AcademicYear";
import Semester from "../components/Dropdown/Semester";
import Level from "@/components/Dropdown/Level.vue";
import Faculty from "@/components/Dropdown/Faculty.vue";
import Department from "@/components/Dropdown/Department.vue";
import MasterDataProvider from "@/services/masterData_provider";
import EnrollProvider from "@/services/enroll_provider";
import GetClassType from "@/components/Dropdown/GetClassType.vue";

const masterDataProvider = new MasterDataProvider();
const enrollProvider = new EnrollProvider();

export default {
  name: "confirmReqRegister",
  components: {
    AcademicYear,
    Semester,
    Level,
    Faculty,
    Department,
    GetClassType,
  },
  data() {
    return {
      dialogSearchProgram: false,
      selYear: 0,
      selSemester: 0,
      selLvl: 0,
      selSection: "00",
      selExReq: "0",
      selConfirm: "0",
      selApprove: "0",
      courseCode: "",
      courseName: "",
      sections: [],
      bTable: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "action",
            label: "",
            thClass: "align-middle",
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStle: "width: 50px",
            sortable: true,
          },
          {
            key: "COURSECODE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            thStle: "width: 50px",
            sortable: true,
          },
          {
            key: "COURSENAME",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            thStle: "width: 250px !important",
            tdClass: "text-left text-nowarp col-250",
            sortable: true,
          },
          {
            key: "SECTION_TEXT",
            label: this.$t("messages.general.section"),
            thClass: "align-middle",
            thStle: "width: 50px",
            sortable: true,
          },          
          {
            key: "TOTALSUMSEAT",
            label: this.$t("messages.general.numberofOpen"),
            tdClass: "text-center text-nowarp",
            thStle: "width: 105px",
            thClass: "align-middle",
            sortable: true,
          },
          {
            key: "TOTALREQUEST",
            label: this.$t("messages.general.inform"),
            thClass: "align-middle",
            thStle: "width: 50px",
            tdClass: "text-right text-nowarp",
            sortable: true,
          },
          {
            key: "TOTALCONFIRM",
            label: this.$t("messages.general.confirmReg"),
            thClass: "align-middle",
            thStle: "width: 50px",
            tdClass: "text-right text-nowarp",
            sortable: true,
          },
          {
            key: "TOTALENROLL",
            label: this.$t("messages.general.register"),
            thClass: "align-middle",
            thStle: "width: 50px",
            tdClass: "text-right text-nowarp",
            sortable: true,
          },
          {
            key: "CONFIRMSTATUS_TEXT",
            label: this.$t("messages.general.confirmStatus"),
            tdClass: "text-center text-nowarp",
            thClass: "align-middle",
            thStle: "width: 90px",
            sortable: true,
          },
          {
            key: "APPROVESTATUS_TEXT",
            label: this.$t("messages.general.approveStatus"),
            tdClass: "text-center text-nowarp",
            thClass: "align-middle",
            thStle: "width: 105px",
            sortable: true,
          },
        ],
      },
      bTableProgram: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStle: "width: 50px",
            sortable: true,
          },
          {
            key: "COURSECODE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            thStle: "width: 100px",
            sortable: true,
          },
          {
            key: "COURSENAME",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp col-250",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp col-150",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp col-200",
            sortable: true,
          },
          {
            key: "COURSEUNIT",
            label: this.$t("messages.general.credit"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            thStle: "width: 100px",
            sortable: true,
          },
        ],
      },
      bTableStudentRegShow: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "STUDENTCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            thStyle: "width: 110px",
            sortable: true,
          },
          {
            key: "STUDENTNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "STUDENT_LEVEL",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "ENROLLSTATUS",
            label: this.$t("messages.general.regisStatus"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
        ],
      },
      perPageOptions: [
        { value: 10, text: 10 },
        { value: 50, text: 50 },
        { value: 100, text: 100 },
        { value: 500, text: 500 },
        { value: 1000, text: 1000 },
        { value: 2000, text: 2000 },
        { value: 3000, text: 3000 },
      ],
      perPage: 100,
      perPageStudentReg: 50,
      currentPage: 1,
      currentPageProgram: 1,
      searched: false,
      selected: false,
      selectedIdx: 0,
      isEdit: false,
      isSpecial: false,
      selectedDetail: false,
      dlgCourseCode: "",
      dlgCourseName: "",
      selDepartmentCourse: 0,
      selType: "",
      selFacultyCourse: 0,
      extraReg: false,
      extraRegVal: false,
      selectedClsId: 0,
      dialogConfirmSuccess: false,
      successText: "",
      dialogError: false,
      errorText: "",
      dialogErrorTitle: "",
      confirmType: 0,
      totalRequest: 0,
      totalConfirm: "",
      isStudentSelect: true,
      dialogStudents: false,
      dialogStudentsShowDetail: false,
      bTableStudentReg: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [],
      },
      currentPageStudentReg: 1,
      studentIdList: [],
      studentList: [],
      tmpStudentList: [],
      tmpStudentIdList: [],
      totalSumSeat: "",
      isEditTotalSumSeat: false,
      dialogRandom: false,
      randomType: "AC",
      totalConfirmDisabled: false,
      isHideButtonandMark: false,
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      mfuUserId: "getMfuUserId",
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
  },
  mounted() {
    this.tokenHealthChk();
    this.togglePreLoader(true);
    this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
    this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
    this.selLvl = 3;
    this.selSection = "00";
    this.selExReq = "0";
    this.selConfirm = "0";
    this.selApprove = "0";
    this.selType = "";
    this.togglePreLoader(false);
  },
  methods: {
    ...mapActions("application", ["togglePreLoader", "tokenHealthChk"]),
    onSelYearChanged(event) {
      this.selYear = parseInt(event.target.value);
      this.getSections();
    },
    onSelSemesterChanged(event) {
      this.selSemester = parseInt(event.target.value);
      this.getSections();
    },
    onSelLvlChanged(event) {
      this.selLvl = parseInt(event.target.value);
    },
    onSelSectionChanged(event) {
      this.selSection = event.target.value;
    },
    onSelExReqChanged(event) {
      this.selExReq = event.target.value;
    },
    onSelConfirmChanged(event) {
      this.selConfirm = event.target.value;
    },
    onSelapproveChanged(event) {
      this.selApprove = event.target.value;
    },
    onSelFacultyCourseChanged() {
      this.selFacultyCourse = parseInt(event.target.value);
    },
    onSelDepartmentCourseChanged(event) {
      this.selDepartmentCourse = parseInt(event.target.value);
    },
    onSelTypeChanged(event) {
      this.selType = event.target.value;
    },
    handleSearchClsKey(event) {
      if (event.charCode == 13) {
        this.handleSearchCls();
      }
    },
    async handleSearchCls() {
      if (this.courseCode != "") {
        this.togglePreLoader(true);
        const result = await enrollProvider.getCourseByAcad({
          token: this.token,
          request: {
            coursecode: this.courseCode,
            acadyear: this.selYear,
            semester: this.selSemester,
            lang: this.currentLang,
          },
        });
        // Fix Dropdown Course List Found Multiple Course
        if (result.code != 500 && result.data.length > 0) {
          if (result.data.length === 0) {
            this.handleSelectClass(result[0]);
            this.courseList = result;
          } else {
            this.courseList = result;
            this.dlgCourseCode = this.courseCode;
            this.dialogSearchProgram = true;
            this.bTableProgram.items = [];
            if (result.data.length > 0) {
              let idx = 0;
              result.data.map((d) => {
                d.rowNumber = idx + 1;
                this.bTableProgram.items.push(d);
                idx++;
              });
            }
          }
        } else {
          this.dialogError = true;
          this.errorText = result.message;
        }
        this.togglePreLoader(false);
      } else {
        this.handleShowDlgSearchCourse();
      }
    },
    handleClrCourse() {
      this.courseCode = "";
      this.courseName = "";
    },
    async handleSelectClass(item) {
      if (item && item.COURSECODE != null) {
        this.courseCode = item.COURSECODE;
        this.courseName = item.COURSENAME;
        await this.getSections();
      }
    },
    async getSections() {
      if (this.selYear != 0 && this.selSemester != 0 && this.courseCode != "") {
        this.togglePreLoader(true);
        const data = await masterDataProvider.getSection({
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            coursecode: this.courseCode,
            lang: this.currentLang,
          },
        });
        this.sections = data;
        this.togglePreLoader(false);
      }
    },
    async handleSearchConfirmResult() {
      this.togglePreLoader(true);
      const result = await enrollProvider.searchConfirmResult({
        token: this.token,
        request: {
          acadyear: this.selYear,
          semester: this.selSemester,
          levelid: this.selLvl,
          coursecode: this.courseCode,
          classtype: this.selType, //ฟิลดิ์ประเภทรายวิชา
          section: this.selSection,
          userid: this.mfuUserId,
          lang: this.currentLang,
          exFlag: this.selExReq,
          confirmFlag: this.selConfirm,
          approveFlag: this.selApprove,
        },
      });
      this.bTable.items = [];
      if (result.length > 0) {
        this.searched = true;
        let idx = 0;
        result.map((d) => {
          d.rowNumber = idx + 1;
          this.bTable.items.push(d);
          idx++;
        });
      }
      this.togglePreLoader(false);
    },
    async getReqConfirmDetail() {
      if (this.selected) {
        this.togglePreLoader(true);
        const result = await enrollProvider.reqConfirmDetail({
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            classid: this.selectedClsId,
            userid: this.mfuUserId,
            // schedule_period: this.appInfo.data.SCHEDULE_PERIOD,
            schedule_period: 1,
            lang: this.currentLang,
          },
        });
        this.togglePreLoader(false);
        if (result.length > 0) {
          this.selectedDetail = result[0];
          this.confirmType = this.selectedDetail.CONFIRMTYPE;
          this.extraReg = this.selectedDetail.IS_SHOWEXTRAREGISTER == "Y";
          this.extraRegVal = this.selectedDetail.EXTRAREGISTER == "Y";
          this.showPerson = this.selectedDetail.IS_SHOWEDITSTUDENT == "Y";
          this.totalRequest = this.selectedDetail.TOTALREQUEST;
          this.totalSumSeat = this.selectedDetail.TOTALSUMSEAT;
          this.totalConfirm =
            this.confirmType == 2 && this.selectedDetail.TOTALCONFIRM
              ? this.selectedDetail.TOTALCONFIRM
              : "";
          this.totalConfirmDisabled = this.confirmType != 2;
          this.isEdit = true;
        }
      }
    },
    handleClearScreen() {
      this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
      this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
      this.selLvl = 3;
      this.selSection = "00";
      this.selExReq = "0";
      this.selConfirm = "0";
      this.selApprove = "0";
      this.handleClrCourse();
      this.selected = false;
      this.searched = false;
      this.selectedIdx = 0;
      this.bTable.items = [];
    },
    goTo(item, index) {
      this.totalConfirm = 0;
      this.selected = item;
      this.selectedIdx = index;
      this.selectedClsId = this.selected.CLASSID;
      this.studentIdList = [];
      this.studentList = [];
      this.getReqConfirmDetail();
    },
    goBack() {
      this.totalConfirm = 0;
      this.selected = false;
      this.selectedIdx = 0;
      this.selectedDetail = false;
      this.extraReg = false;
      this.isEdit = false;
      this.studentIdList = [];
      this.studentList = [];
      this.dialogRandom = false;
      this.handleSearchConfirmResult();
    },
    async handleSelectTotalConfirm(item, id) {
      this.classid = item.CLASSID;
      this.bTableStudentRegShow.items = [];
      this.togglePreLoader(true);
      const res = await enrollProvider.getStdconfirmdetail({
        token: this.token,
        request: {
          classid: item.CLASSID,
          lang: this.currentLang,
        },
      });
      let idx = 0;
      this.togglePreLoader(false);
      if (res.length > 0) {
        res.map((d) => {
          d.rowNumber = idx + 1;
          this.bTableStudentRegShow.items.push(d);
          idx++;
        });
      }
      this.dialogStudentsShowDetail = true;
    },
    async handleSelectTotalEnroll(item, id) {
      this.classid = item.CLASSID;
      // this.handleStudentSelectList();
      this.isStudentSelect = false;
      this.bTableStudentReg.items = [];
      this.tmpStudentList = [];
      this.tmpStudentIdList = [];
      this.bTableStudentReg.fields = [
        // {
        //   key: "selStudent",
        //   label: "",
        //   thClass: "align-middle",
        // },
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "STUDENTCODE_TEXT",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          thStyle: "width: 110px",
          sortable: true,
        },
        {
          key: "STUDENTNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "STUDENT_LEVEL",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          thStyle: "width: 180px",
          sortable: true,
        },
      ];
      this.togglePreLoader(true);
      const res = await enrollProvider.getStdenrolldetail({
        token: this.token,
        request: {
          classid: item.CLASSID,
          lang: this.currentLang,
        },
      });
      let idx = 0;
      this.togglePreLoader(false);
      if (res.length > 0) {
        res.map((d) => {
          d.rowNumber = idx + 1;
          d.selStudent = false;
          d.isApi = true;
          this.bTableStudentReg.items.push(d);
          idx++;
        });
      }
      this.isHideButtonandMark = true;
      this.dialogStudents = true;
    },
    handleShowDlgSearchCourse() {
      this.cleartCourseProgram();
      this.dialogSearchProgram = true;
    },
    async handleCourseSearch() {
      //if (this.dlgCourseCode != "" || this.dlgCourseName != "") {
      this.togglePreLoader(true);
      const result = await enrollProvider.getCourseByAcad({
        token: this.token,
        request: {
          coursecode: this.dlgCourseCode,
          coursename: this.dlgCourseName,
          facultyid: this.selFacultyCourse,
          departmentid: this.selDepartmentCourse,
          acadyear: this.selYear,
          semester: this.selSemester,
          lang: this.currentLang,
        },
      });
      this.bTableProgram.items = [];
      if (result.code != 500 && result.data.length > 0) {
        let idx = 0;
        result.data.map((d) => {
          d.rowNumber = idx + 1;
          this.bTableProgram.items.push(d);
          idx++;
        });
      } else {
        this.dialogError = true;
        this.errorText = result.message;
      }
      this.togglePreLoader(false);
      // } else {
      //   this.dialogError = true;
      //   this.errorText = this.$t("messages.general.programCodeNameReq");
      // }
    },
    cleartCourseProgram() {
      this.dlgCourseCode = "";
      this.dlgCourseName = "";
      this.selFacultyCourse = 0;
      this.selDepartmentCourse = 0;
      this.bTableProgram.items = [];
    },
    async handleSelectCourse(item, idx) {
    //  console.log(idx);
      this.courseCode = item.COURSECODE;
      this.courseName = item.COURSENAME;
      await this.getSections();
      this.dialogSearchProgram = false;
    },
    async handleExtraReqEdit() {
      this.togglePreLoader(true);
      this.dialogError = false;
      this.isShowCaution = false;
      this.dialogErrorTitle = "";
      this.errorText = "";
      const res = await enrollProvider.adjustExtraRegister({
        token: this.token,
        request: {
          classid: this.selectedClsId,
          extraregister: this.extraRegVal ? "Y" : "N",
          userid: this.mfuUserId,
          lang: this.currentLang,
        },
      });
      this.togglePreLoader(false);
      if (res.code == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${res.message}<br/>`;
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${res.message}<br/>`;
      }
    },
    handleEditTotalSeat() {
      this.isEditTotalSumSeat = true;
    },
    async handleAdjustTotalSeat() {
      if (this.totalSumSeat == "") return;
      this.togglePreLoader(true);
      // const resIp = await masterDataProvider.getCurrentIP();
      this.dialogError = false;
      this.isShowCaution = false;
      this.dialogErrorTitle = "";
      this.errorText = "";
      const res = await enrollProvider.adjustTotalSeat({
        token: this.token,
        request: {
          classid: this.selectedClsId,
          totalsumseat: this.totalSumSeat == "" ? 0 : this.totalSumSeat,
          userid: this.mfuUserId,
          ipaddress: "127.0.0.1", // resIp.ip,
          lang: this.currentLang,
        },
      });
      this.togglePreLoader(false);
      if (res.code == 200) {
        this.getReqConfirmDetail()
        this.dialogConfirmSuccess = true;
        this.successText = `${res.message}<br/>`;
        this.isEditTotalSumSeat = false;
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${res.message}<br/>`;
      }
    },
    handleClearTotalSeat() {
      this.isEditTotalSumSeat = false;
    },
    async handleConfirmReq() {
      if(this.confirmType == 1 && this.selectedDetail.REMAINSEAT < this.totalRequest) {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = this.$t("messages.general.warnRemainSeatLessThanRequest");
        return;
      }

      if (this.confirmType == 2 && this.totalConfirm == "") {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = this.$t("messages.general.warnTotalConfirm");
        return;
      }
      if (
        (this.confirmType == 2 &&
          this.selectedDetail.REMAINSEAT < this.totalConfirm) ||
        (this.confirmType == 3 &&
          this.selectedDetail.REMAINSEAT < this.studentIdList.length)
      ) {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = this.$t("messages.general.warnRemainSeat");
        return;
      }

      this.togglePreLoader(true);
      // const resIp = await masterDataProvider.getCurrentIP();
      let totalConfirmAmt = 0;
      if (this.confirmType == 0) {
        totalConfirmAmt = this.selectedDetail.ROOMCAPACITY;
      } else if (this.confirmType == 1) {
        totalConfirmAmt = this.totalRequest;
      } else if (this.confirmType == 2) {
        totalConfirmAmt = this.totalConfirm;
      } else if (this.confirmType == 3) {
        totalConfirmAmt = this.studentIdList.length;
      }
      const res = await enrollProvider.reqConfirm({
        token: this.token,
        request: {
          acadyear: this.selYear,
          semester: this.selSemester,
          classid: this.selectedClsId,
          confirmtype: this.confirmType,
          totalrequest: this.totalRequest,
          totalconfirm: totalConfirmAmt,
          studentidlist: this.studentIdList,
          userid: this.mfuUserId,
          ipaddress: "127.0.0.1", // resIp.ip,
          lang: this.currentLang,
        },
      });
      this.togglePreLoader(false);
      if (res.code == 200) {
        this.studentIdList = [];
        this.studentList = [];
        // this.dialogConfirmSuccess = true;
        // this.successText = `${res.message}<br/>`;
        this.dialogRandom = true;
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${res.message}<br/>`;
      }
    },
    async handleGetReqConfirmStudentDetail() {
      this.isStudentSelect = true;
      this.togglePreLoader(true);
      const res = await enrollProvider.reqConfirmStudentDetail({
        token: this.token,
        request: {
          classid: this.selectedClsId,
          formtype: "edit",
          lang: this.currentLang,
        },
      });
      this.togglePreLoader(false);
      this.bTableStudentReg.items = [];
      this.tmpStudentList = [];
      this.tmpStudentIdList = [];
      this.bTableStudentReg.fields = [
        {
          key: "selStudent",
          label: "",
          thClass: "align-middle",
        },
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "STUDENTCODE_TEXT",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          thStyle: "width: 110px",
          sortable: true,
        },
        {
          key: "STUDENTNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "STUDENT_LEVEL",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "REASON",
          label: this.$t("messages.general.reason"),
          thClass: "align-middle",
          thStyle: "width: 250px",
          tdClass: "text-left",
          sortable: true,
        },
      ];
      const thisStudentList = this.studentList;
      if (res.length > 0) {
        let idx = 0;
        res.map((d) => {
          d.rowNumber = idx + 1;
          const found = thisStudentList.find((s) => s.STUDENTID == d.STUDENTID);
          d.selStudent = found !== undefined;
          if (d.selStudent) {
            this.tmpStudentList.push(found);
            this.tmpStudentIdList.push(found.STUDENTID);
          }
          this.bTableStudentReg.items.push(d);
          idx++;
        });
      }
      this.isHideButtonandMark = false;
      this.dialogStudents = true;
    },
    handleChkAll(e) {
      const isChecked = e.target.checked;
      this.bTableStudentReg.items.map((i) => {
        i.selStudent = e.target.checked;
        if (isChecked) {
          this.tmpStudentIdList.push(i.STUDENTID);
          this.tmpStudentList.push(i);
        }
      });
      if (!isChecked) {
        this.tmpStudentIdList = [];
        this.tmpStudentList = [];
      }
    },
    async handleStudentSelect() {
      if (this.isStudentSelect) {
        this.studentIdList = this.tmpStudentIdList;
        this.studentList = this.tmpStudentList;
      } else {
        const filterApiIds = [];
        const filterIds = [];
        const filterItems = [];
        this.tmpStudentList.forEach((s) => {
          if (s.isApi) {
            filterApiIds.push(s.STUDENTID);
          } else {
            const found = this.studentList.find(
              (t) => t.STUDENTID == s.STUDENTID
            );
            if (found == undefined) {
              filterItems.push(s);
              filterIds.push(s.STUDENTID);
            }
          }
        });
        if (filterApiIds.length > 0) {
          this.togglePreLoader(true);
          const res = await enrollProvider.delReqConfirmStudentDetail({
            token: this.token,
            request: {
              classid: this.selectedClsId,
              studentidlist: filterApiIds,
              userid: this.mfuUserId,
              lang: this.currentLang,
            },
          });
          this.togglePreLoader(false);
          if (res.code == 200) {
            this.dialogConfirmSuccess = true;
            this.successText = `${res.message}<br/>`;
          } else {
            this.dialogErrorTitle = "";
            this.dialogError = true;
            this.errorText = `${res.message}<br/>`;
          }
        }
        this.studentIdList = filterIds;
        this.studentList = filterItems;
      }
      this.dialogStudents = false;
    },
    handleChk(e, data) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      this.bTableStudentReg.items[index].selStudent = isChecked;
      if (isChecked) {
        this.tmpStudentIdList.push(item.STUDENTID);
        this.tmpStudentList.push(item);
      } else {
        const newIdArr = this.tmpStudentIdList.filter(
          (c) => c != item.STUDENTID
        );
        this.tmpStudentIdList = newIdArr;
        const newArr = this.tmpStudentList.filter(
          (c) => c.STUDENTID != item.STUDENTID
        );
        this.tmpStudentList = newArr;
      }
    },
    async handleStudentSelectList() {
      this.isStudentSelect = false;
      this.bTableStudentReg.items = [];
      this.tmpStudentList = [];
      this.tmpStudentIdList = [];
      this.bTableStudentReg.fields = [
        // {
        //   key: "selStudent",
        //   label: "",
        //   thClass: "align-middle",
        // },
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "STUDENTCODE_TEXT",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          thStyle: "width: 110px",
          sortable: true,
        },
        {
          key: "STUDENTNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "STUDENT_LEVEL",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
      ];
      this.togglePreLoader(true);
      const res = await enrollProvider.reqConfirmStudentDetail({
        token: this.token,
        request: {
          classid: this.selectedClsId,
          formtype: "view",
          lang: this.currentLang,
        },
      });
      let idx = 0;
      this.togglePreLoader(false);
      if (res.length > 0) {
        res.map((d) => {
          d.rowNumber = idx + 1;
          d.selStudent = false;
          d.isApi = true;
          this.bTableStudentReg.items.push(d);
          //this.studentIdList.push(d.STUDENTID);
          //this.studentList.push(d);
          idx++;
        });
      }
      // this.studentList.map(s => {
      //   s.rowNumber = idx + 1;
      //   s.selStudent = false;
      //   if (s.isApi == undefined) {
      //     s.isApi = false;
      //   }
      //   this.bTableStudentReg.items.push(s);
      //   idx++;
      // });
      this.dialogStudents = true;
    },
    async handleApprove() {
      this.togglePreLoader(true);
      const tmpList = [];
      tmpList.push(this.selectedClsId);
      // const resIp = await masterDataProvider.getCurrentIP();
      const res = await enrollProvider.preApprove({
        token: this.token,
        request: {
          acadyear: this.selYear,
          semester: this.selSemester,
          classidlist: tmpList,
          approvetype: this.randomType,
          userid: this.mfuUserId,
          ipaddress: "127.0.0.1", // resIp.ip,
          lang: this.currentLang,
        },
      });
      this.togglePreLoader(false);
      if (res.code == 200) {
        this.dialogRandom = false;
        this.dialogConfirmSuccess = true;
        this.successText = `${res.message}<br/>`;
        this.goBack();
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${res.message}<br/>`;
      }
    },
  },
  watch: {
    confirmType(val) {
      if (val == 2) {
        this.totalConfirm =
          this.selectedDetail.CONFIRMTYPE == 2
            ? this.selectedDetail.TOTALCONFIRM
            : "";
        this.showPerson = false;
        this.totalConfirmDisabled = false;
      } else if (val == 3) {
        this.totalConfirm = "";
        this.showPerson = true;
        this.totalConfirmDisabled = true;
      } else {
        this.totalConfirm = "";
        this.showPerson = false;
        this.totalConfirmDisabled = true;
      }
    },
    currentLang() {
      if (this.searched) {
        this.handleSearchConfirmResult();
      }
      this.getReqConfirmDetail();
      this.bTable.fields = [
        {
          key: "action",
          label: "",
          thClass: "align-middle",
        },
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStle: "width: 50px",
          sortable: true,
        },
        {
          key: "COURSECODE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          thStle: "width: 50px",
          sortable: true,
        },
        {
          key: "COURSENAME",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          thStle: "width: 250px !important",
          tdClass: "text-left text-nowarp",
        },
        {
          key: "SECTION_TEXT",
          label: this.$t("messages.general.section"),
          thClass: "align-middle",
          thStle: "width: 50px",
          sortable: true,
        },
        {
          key: "TOTALSUMSEAT",
          label: this.$t("messages.general.numberofOpen"),
          tdClass: "text-center text-nowarp",
          thStle: "width: 105px",
          thClass: "align-middle",
          sortable: true,
        },
        {
          key: "TOTALREQUEST",
          label: this.$t("messages.general.inform"),
          thClass: "align-middle",
          thStle: "width: 50px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "TOTALCONFIRM",
          label: this.$t("messages.general.confirmReg"),
          thClass: "align-middle",
          thStle: "width: 50px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "TOTALENROLL",
          label: this.$t("messages.general.register"),
          thClass: "align-middle",
          thStle: "width: 50px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "CONFIRMSTATUS_TEXT",
          label: this.$t("messages.general.confirmStatus"),
          tdClass: "text-center text-nowarp",
          thStle: "width: 90px",
          thClass: "align-middle",
          sortable: true,
        },
        {
          key: "APPROVESTATUS_TEXT",
          label: this.$t("messages.general.approveStatus"),
          tdClass: "text-center text-nowarp",
          thClass: "align-middle",
          thStle: "width: 105px",
          sortable: true,
        },
      ];
      this.bTableProgram.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStle: "width: 50px",
          sortable: true,
        },
        {
          key: "COURSECODE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          thStle: "width: 100px",
          sortable: true,
        },
        {
          key: "COURSENAME",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp col-250",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp col-150",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp col-200",
          sortable: true,
        },
        {
          key: "COURSEUNIT",
          label: this.$t("messages.general.credit"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          thStle: "width: 100px",
          sortable: true,
        },
      ];
      this.bTableStudentRegShow.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "STUDENTCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          thStyle: "width: 110px",
          sortable: true,
        },
        {
          key: "STUDENTNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "STUDENT_LEVEL",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
          {
            key: "ENROLLSTATUS",
            label: this.$t("messages.general.regisStatus"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
      ];
      if (this.isStudentSelect) {
        this.bTableStudentReg.fields = [
          {
            key: "selStudent",
            label: "",
            thClass: "align-middle",
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "STUDENTCODE_TEXT",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            thStyle: "width: 110px",
            sortable: true,
          },
          {
            key: "STUDENTNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "STUDENT_LEVEL",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "REASON",
            label: this.$t("messages.general.reason"),
            thClass: "align-middle",
            thStyle: "width: 250px",
            tdClass: "text-left",
            sortable: true,
          },
        ];
      } else {
        this.bTableStudentReg.fields = [
          {
            key: "selStudent",
            label: "",
            thClass: "align-middle",
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thStyle: "width: 50px",
            thClass: "align-middle",
            sortable: true,
          },
          {
            key: "STUDENTCODE_TEXT",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            thStyle: "width: 110px",
            sortable: true,
          },
          {
            key: "STUDENTNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "STUDENT_LEVEL",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
        ];
      }
    },
  },
};
</script>
